import { useLazyFetchGraphql } from '@zoopla/fetch-graphql';
import { GraphQLError } from 'graphql';
import {
    UpdateUserProfileDocument,
    UpdateUserProfileMutation
} from '@zoopla/user-queries';

export const UNSAVED_STORAGE_KEY = 'unsavedSituationAnswers';

export const useSaveGuestSituationData = () => {
    const { lazyFetch: updateUserProfile } =
        useLazyFetchGraphql<UpdateUserProfileMutation>(
            UpdateUserProfileDocument
        );

    const hasSavedAnswers = (): boolean => {
        if (typeof window === 'undefined') {
            return false;
        }

        return sessionStorage?.getItem(UNSAVED_STORAGE_KEY) !== null;
    };

    const getSavedAnswers = () => {
        if (typeof window === 'undefined') {
            return;
        }

        return sessionStorage?.getItem(UNSAVED_STORAGE_KEY);
    };

    const removeSavedAnswers = () => {
        if (typeof window === 'undefined') {
            return;
        }

        return sessionStorage?.removeItem(UNSAVED_STORAGE_KEY);
    };

    const saveSituationData = async (): Promise<
        | {
              data?: UpdateUserProfileMutation | undefined;
              error?: GraphQLError[] | null | undefined;
          }
        | undefined
    > => {
        if (typeof window === 'undefined') {
            return;
        }

        const unsavedSituationInStorage =
            sessionStorage?.getItem(UNSAVED_STORAGE_KEY) ?? null;

        if (unsavedSituationInStorage === null) {
            throw new Error('Cannot find any saved answers');
        }

        const unsavedData = JSON.parse(unsavedSituationInStorage);

        if (Object.keys(unsavedData).length === 0) {
            return;
        }

        // add flag to localstorage to avoid showing modal again
        localStorage.setItem('your-situation-modal-lsrp-completed', 'true');

        return await updateUserProfile({
            input: {
                ...unsavedData
            }
        });
    };

    return {
        saveSituationData,
        hasSavedAnswers,
        getSavedAnswers,
        removeSavedAnswers
    };
};
